import { ActionIcon, ActionIconProps, Tooltip } from "@mantine/core"
import { IconMaximize, IconMinimize } from "@tabler/icons-react"
import { useTranslation } from "react-i18next"

interface Props extends ActionIconProps {
  onClick: (maximized: boolean) => void
}

export function ToggleMaximizeActionIcon({
  onClick,
  ...actionIconProps
}: Props) {
  const [maximized, setMaximized] = React.useState(false)
  const { t } = useTranslation("app_server")
  return (
    <Tooltip label={maximized ? t("ExitFullscreen") : t("Fullscreen")}>
      <ActionIcon
        variant="subtle"
        {...actionIconProps}
        onClick={() => {
          const newMaximized = !maximized
          setMaximized(newMaximized)
          onClick(newMaximized)
        }}
      >
        {maximized ? <IconMinimize /> : <IconMaximize />}
      </ActionIcon>
    </Tooltip>
  )
}
